"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hat = void 0;
var figureBase_1 = require("../../../core/base/figureBase");
var line3_1 = require("../../../core/base/line3");
var three_1 = require("three");
var Hat = /** @class */ (function (_super) {
    __extends(Hat, _super);
    function Hat() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Hat.prototype.calculateConnectionIndexes = function () {
        return [0, 1, 3, 4, 5, 7];
    };
    Hat.prototype.calculateLines = function () {
        var coords = this.config.options;
        var aPoint = new three_1.Vector3(coords.w2 / 2, 0);
        var bPoint = new three_1.Vector3(-coords.w2 / 2, 0);
        var cPoint = new three_1.Vector3(-coords.w1 / 2, coords.hBottom);
        var dPoint = new three_1.Vector3(-coords.wa / 2, coords.hBottom);
        var ePoint = new three_1.Vector3(-coords.wa / 2, coords.hBottom + coords.hTop);
        var fPoint = new three_1.Vector3(coords.wa / 2, coords.hBottom + coords.hTop);
        var gPoint = new three_1.Vector3(coords.wa / 2, coords.hBottom);
        var hPoint = new three_1.Vector3(coords.w1 / 2, coords.hBottom);
        return [
            new line3_1.Line3(line3_1.LineType.Straight, [aPoint, bPoint]),
            new line3_1.Line3(line3_1.LineType.Straight, [bPoint, cPoint]),
            new line3_1.Line3(line3_1.LineType.Straight, [cPoint, dPoint]),
            new line3_1.Line3(line3_1.LineType.Straight, [dPoint, ePoint]),
            new line3_1.Line3(line3_1.LineType.Straight, [ePoint, fPoint]),
            new line3_1.Line3(line3_1.LineType.Straight, [fPoint, gPoint]),
            new line3_1.Line3(line3_1.LineType.Straight, [gPoint, hPoint]),
            new line3_1.Line3(line3_1.LineType.Straight, [hPoint, aPoint]),
        ];
    };
    Hat.prototype.getConfigProperties = function () {
        return {
            wa: 0.7,
            hTop: 0.2,
            w1: 0.7,
            w2: 1,
            hBottom: 0.2,
        };
    };
    return Hat;
}(figureBase_1.FigureBase));
exports.Hat = Hat;
